import LePaging from './src';

// 为组件提供 install 安装方法，供按需引入
LePaging.install = function(Vue) {
  Vue.component(LePaging.name, LePaging);
};

// 导出组件
export default LePaging;
